<div class="sort-label" title="{{ displayName }}">
	<ng-content></ng-content>
	&nbsp; &nbsp;
	<span class="sort-indicator-wrapper">
		<mat-icon
			[ngClass]="{
				'sort-indicator': true,
				'sort-idle': sortDirection !== 'ASC',
				'sort-hidden': sortDirection === 'DESC'
			}"
		>
			arrow_drop_up
		</mat-icon>

		<mat-icon
			[ngClass]="{
				'sort-indicator': true,
				'sort-idle': sortDirection !== 'DESC',
				'sort-hidden': sortDirection === 'ASC'
			}"
		>
			arrow_drop_down
		</mat-icon>
	</span>
</div>
